import React, { useEffect, useState, useContext } from "react";
import { Modal } from "react-bootstrap";
import Button from "@mui/material/Button";
import Sidebar from "../../layout/Sidebar/SideBar";
import Navbar from "../../layout/Navbar/Navbar";
import LoadingButton from "@mui/lab/LoadingButton";
import { getIdCompany } from "../../utils/constantes";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import blogFetch from "../../axios/config";
import RegisterQuestions from "./RegisterQuestion";
import Context from "../../context/Context";
import language from "../../nls/language.json";
import "../../styles/Style.css";

function Question() {
  const [questions, setQuestions] = useState([]);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [questionsId, setquestionsId] = useState(0);
  const [loading, setLoading] = useState(false);
  const { useRef } = React;
  const ref = useRef();

  const {
    getStatusSideBar,
    selectedCountry
  } = useContext(Context);

  useEffect(() => {
    getQuestions();
  }, []);
  
  const getQuestions = async () => {
    try {
      let response = await blogFetch.get(
        `/question?companyId=${getIdCompany()}`
      );
      let data = response.data;
      setQuestions(data);
    } catch (error) {
      console.error(error);
    }
  };

  const deleteQuestions = async (qeS_PK_idQuestion) => {
    try {
      await blogFetch.delete(`/question/${qeS_PK_idQuestion}`);
      getQuestions();
    } catch (error) {
      console.error(error);
    }
  };

  const modalAdd = () => {
    return (
      <Modal show={showModalAdd} onHide={() => setShowModalAdd(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {language[selectedCountry.name].Cadastro.perguntas.modal.adicionar.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RegisterQuestions ref={ref}></RegisterQuestions>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="text"
            sx={{ marginRight: 2 }}
            onClick={() => setShowModalAdd(false)}
          >
            {language[selectedCountry.name].Cadastro.perguntas.modal.adicionar.btnCancelar}
          </Button>{" "}
          <LoadingButton
            loading={loading}
            variant="contained"
            onClick={async () => {
              setLoading(true);
              try {
                await ref.current.addQuestions();
                setLoading(false);
                setShowModalAdd(false);
                getQuestions();
              } catch (error) {
                console.error();
                setLoading(false);
              }
            }}
          >
            {language[selectedCountry.name].Cadastro.perguntas.modal.adicionar.btnSalvar}
          </LoadingButton>
        </Modal.Footer>
      </Modal>
    );
  };

  const modalEdit = () => {
    return (
      <Modal show={showModalEdit} onHide={() => setShowModalEdit(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {language[selectedCountry.name].Cadastro.perguntas.modal.editar.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <RegisterQuestions
            ref={ref}
            idQuestions={questionsId}
          ></RegisterQuestions>
        </Modal.Body>{" "}
        <Modal.Footer>
          <Button
            variant="text"
            sx={{ marginRight: 2 }}
            onClick={() => setShowModalEdit(false)}
          >
            {language[selectedCountry.name].Cadastro.perguntas.modal.editar.btnCancelar}
          </Button>{" "}
          <LoadingButton
            loading={loading}
            variant="contained"
            onClick={async () => {
              setLoading(true);
              try {
                await ref.current.updateQuestions();
                setLoading(false);
                setShowModalEdit(false);
                getQuestions();
              } catch (error) {
                console.error();
                setLoading(false);
              }
            }}
          >
            {language[selectedCountry.name].Cadastro.perguntas.modal.editar.btnSalvar}
          </LoadingButton>
        </Modal.Footer>
      </Modal>
    );
  };

  const modalDelete = () => {
    return (
      <Modal show={showModalDelete} onHide={() => setShowModalDelete(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {language[selectedCountry.name].Cadastro.perguntas.modal.deletar.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body ref={ref} idQuestions={questionsId}>
          {language[selectedCountry.name].Cadastro.perguntas.modal.deletar.corpoModal}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="text"
            sx={{ marginRight: 2 }}
            onClick={() => setShowModalDelete(false)}
          >
            {language[selectedCountry.name].Cadastro.perguntas.modal.deletar.btnCancelar}
          </Button>{" "}
          <LoadingButton
            loading={loading}
            variant="contained"
            onClick={async () => {
              setLoading(true);
              try {
                await deleteQuestions(questionsId);
                setLoading(false);
                setShowModalDelete(false);
                getQuestions();
              } catch (error) {
                console.error();
                setLoading(false);
              }
            }}
          >
            {language[selectedCountry.name].Cadastro.perguntas.modal.deletar.btnSalvar}
          </LoadingButton>
        </Modal.Footer>
      </Modal>
    );
  };

  const typeAnswer = (id) => {
    if (id === 1) {
      return "Sim/Não";
    } else if (id === 2) {
      return "Pré-selecionada";
    } else if (id === 3) {
      return "Aberta";
    }
  };

  return (
    <div>
      <Navbar />
      <Sidebar />
      <div className={`app_body ${getStatusSideBar()}`}>
        <div className="header_tables_view">
          <div></div>
          <div>
            <h3 className="title_tables">
              {language[selectedCountry.name].Cadastro.perguntas.title}
            </h3>
          </div>
          <div>
            <Button
              className="add_button"
              variant="contained"
              onClick={() => setShowModalAdd(true)}
            >
              {language[selectedCountry.name].Cadastro.perguntas.btnAdicionar}
            </Button>
          </div>
        </div>
        <table className="table table-hover">
          <thead className="table-header">
            <tr className="table_row">
              <th>#</th>
              <th>{language[selectedCountry.name].Cadastro.perguntas.tableHeader.title}</th>
              <th>{language[selectedCountry.name].Cadastro.perguntas.tableHeader.tipoResposta}</th>
              <th className="edit">{language[selectedCountry.name].Cadastro.perguntas.tableHeader.editar}</th>
            </tr>
          </thead>
          <tbody className="table_row">
            {!!questions &&
              Object.entries(questions).map((item) => (
                <tr key={item[1].qeS_PK_idQuestion}>
                  <td>{item[1].qeS_PK_idQuestion}</td>
                  <td>{item[1].qeS_description}</td>
                  <td>{typeAnswer(item[1].qeS_typeAnswer)}</td>
                  <td className="edit">
                    <center>
                      <ModeEditIcon
                        onClick={() => {
                          setquestionsId(item[1].qeS_PK_idQuestion);
                          setShowModalEdit(true);
                        }}
                      />
                    </center>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      {modalAdd()}
      {modalDelete()}
      {modalEdit()}
    </div>
  );
}

export default Question;
